const locales = {
  ar: 'ara',
  eu: 'baq',
  ca: 'cat',
  zh: 'chi',
  cs: 'cze',
  da: 'dan',
  nl: 'dut',
  en: 'eng',
  fi: 'fin',
  fr: 'fre',
  de: 'ger',
  ga: 'gle',
  el: 'gre',
  he: 'heb',
  hi: 'hin',
  id: 'ind',
  it: 'ita',
  mu: 'mul',
  no: 'nor',
  fa: 'per',
  pl: 'pol',
  pt: 'por',
  ru: 'rus',
  si: 'sin',
  es: 'spa',
  sv: 'swe',
  th: 'tha',
  tr: 'tur',
  uk: 'ukr',
  ur: 'urd',
  vi: 'vie',
  cy: 'wel'
}

export default function mapLocale(locale) {
  if (locale in locales) {
    return locales[locale]
  }

  return locales.en
}
